import { AssetGroup } from "./schema";
import get from "lodash.get";

export function getLastAssetGroup(assetGroups: AssetGroup[]) {
  return get(assetGroups, assetGroups.length - 1);
}
